import {Button, Col, Row} from "reactstrap";
import {CustomInput} from "../../Common/Components/Input/CustomInput";
import RequestReimbursementExpense from "../Models/Request/RequestReimbursementExpense";
import React, {useEffect, useRef, useState} from "react";
import {CustomSubmitButton} from "../../Common/Components/Input/CustomSubmitButton";
import _ from 'lodash';
import {useTranslation} from "react-i18next";
import {InputMessage} from "../../AppSystem/Helpers/InputMessage";
import {InfoPageMessage} from "../../Common/Components/Button/InfoPageMessage";
import { SlidePanel } from "../../Common/Components/Modal/SlidePanel";

export function ReimbursementExpense({ data, onChange, onValidate, onCancel, editMode = false, accountingJson, extraField, setIsDeletedFile, setIsDeletedExtraFile, extraField2, attributeValue = null, setLocalDisplay, localDisplay, savedExpenses = null}) {
    const { t } = useTranslation();

    const [cancelModel, setCancelModel] = useState(data);

    // STATES
    const [accordionStatus, setAccordionStatus] = useState('1');
    const [flagDate, setFlagDate] = useState(true);
    const [wrongFileFormat, setWrongFileFormat] = useState(false);
    //const [localDisplay, setLocalDisplay] = useState(false);

    const [selectedOption, setSelectedOption] = useState(null);
    const [panelOpen, setPanelOpen] = useState(false);
    const formDivRefExpense = useRef(null);
    const initialDataRef = useRef(null);

    const captureSnapshot = () => {
        initialDataRef.current = _.cloneDeep(data);
    };

    useEffect(() => {
        if (data?.additionalInfo?.program && data?.additionalInfo?.program !== "") {
            setSelectedOption("option1");
        } else if (data?.additionalInfo?.participantsFileId && data?.additionalInfo?.participantsFileId !== "") {
            setSelectedOption("option2");
        } else if (data?.additionalInfo?.program === "" && data?.additionalInfo?.participantsFileId === "") {
            setSelectedOption(null);
        }
    }, [data?.additionalInfo?.program, data?.additionalInfo?.participantsFileId]);

    useEffect(() => {
    // Opciones a comprobar
        const validNames = [
            "Övriga möten fika under 60 kr/person (6071)",
            "Mat och fika över 60 kr/person samt avtackningsgåvor (6072)",
            "Öppna aktiviteter fika under 60 kr/person och lokal (6073)"
        ];
        if (Array.isArray(data?.requiredDocumentation) && data.requiredDocumentation.length > 0 && Array.isArray(savedExpenses) && savedExpenses.length > 0) {
            const filtered = savedExpenses.filter(e => e.accountingName === data.accountingName);
            if (filtered.length > 0) {
                applyLastExpenseValues(filtered[filtered.length - 1]);
            }
        }
    }, [data?.accountingName, savedExpenses]);

    function applyLastExpenseValues(lastExpense) {
        if (!lastExpense) return;
        const fieldsToUpdate = [];
        if (lastExpense.additionalInfo?.program && lastExpense.additionalInfo.program !== "") {
            setSelectedOption("option1");
            onChange({ target: { value: lastExpense.additionalInfo.program } }, "dynamicLastExpense");
        } else {
            setSelectedOption("option2");
            onChange({ target: { value: lastExpense.additionalInfo.participantsFileId, fileExtension: lastExpense.additionalFileExtension } }, "additionalInfoFileId");
        }
        if (lastExpense.additionalInfo?.programFileId && lastExpense.additionalInfo.programFileId !== "") {
            onChange({ target: { value: lastExpense.additionalInfo.programFileId, valueProgram: lastExpense.additionalInfo.program, fileExtension: lastExpense.additionalFileExtension } }, "additionalInfoProgramFileId");
        }
        fieldsToUpdate.forEach((field) => {
            if (lastExpense[field] !== undefined && lastExpense[field] !== null) {
                onChange({ target: { value: lastExpense[field].toString() } }, field);
            }
        });
    }

    useEffect(() => {
        if (editMode === true) {
            const copyModel = _.cloneDeep(data);
            setCancelModel(copyModel);
            captureSnapshot();
            setPanelOpen(true);
            if (setLocalDisplay) setLocalDisplay(true);
        }
    }, [editMode]);

    // keep localDisplay in sync for parent (ReportProceedingV2 uses it)
    useEffect(() => {
        if (setLocalDisplay) setLocalDisplay(panelOpen);
    }, [panelOpen]);

    const messageAccounting = InputMessage(accountingJson.accounting, data?.accountingId);

    const handleClose = () => {
        setPanelOpen(false);
        if (editMode) onCancel(cancelModel);
    };

    const isButtonDisabled =
        !data?.fileId        || data.fileId === ''      ||
        !data?.dateReceive   || data.dateReceive === ''  ||
        !data?.accountingId  || data.accountingId === '' ||
        !data?.amount        || data.amount <= 0         ||
        // Only validate VAT if it's provided (since it's an optional field), 
        // and only if amount is valid (greater than 0)
        (data?.vatAmount !== null && data?.vatAmount !== undefined && (
            data.vatAmount <= 0 || Number(data.vatAmount) >= Number(data.amount)
        ));
    const hasUnsavedChanges = !_.isEqual(data, initialDataRef.current);

    return (
        <>
            {/* Trigger button */}
            <button
                type="button"
                onClick={() => {
                    captureSnapshot();
                    setPanelOpen(true);
                }}
                className="rfc-trigger-btn"
            >
                <div className="rfc-trigger-btn-left">
                    <i className="bx bx-receipt fs-5" />
                    {t('reimbursement.expense')}
                </div>
                <i className="bx bx-chevron-right fs-5" />
            </button>

            <SlidePanel
                isOpen={panelOpen}
                onClose={handleClose}
                title={t('reimbursement.expense')}
                zIndexOffset={20}
                variant="center"
                closeOnOutsideClick={false}
            >
                <div className="accordion-body rfc-panel-body-expense" ref={formDivRefExpense}>
                    <Row>
                        {/* 1. Archivo primero */}
                        <Col lg={12} className="pt-3">
                            <CustomInput
                                model={RequestReimbursementExpense}
                                attribute='fileId'
                                data={''}
                                customChange={(e) => onChange(e, "fileId")}
                                fileId={data?.fileId !== "" ? data?.fileId : null}
                                fileExtension={data?.fileExtension && data?.fileExtension !== "" ? data?.fileExtension : null}
                                fileName={data?.fileName && data?.fileName !== "" ? data?.fileName : (data?.fileExtension && data?.fileExtension !== "" ? data?.fileExtension : null)}
                                wrongFileFormat={wrongFileFormat}
                                setIsDeleted={setIsDeletedFile}
                                validateAttribute={attributeValue}
                            />
                        </Col>

                        {/* 2. Fecha */}
                        <Col lg={12} className="pt-3">
                            <CustomInput model={RequestReimbursementExpense} attribute='dateReceive' data={data?.dateReceive} customChange={(e) => onChange(e, "dateReceive")} />
                        </Col>

                        {/* 3. Tipo de utlägg */}
                        <Col lg={12} className="pt-3">
                            <CustomInput
                                model={RequestReimbursementExpense}
                                attribute='accountingId'
                                data={data?.accountingId}
                                customChange={(e) => onChange(e, "accountingId")}
                                customOptions={Object.keys(accountingJson).length > 0 ? accountingJson : null}
                            />
                            {messageAccounting}
                        </Col>

                        {/* 4. Importe + IVA */}
                        <Col lg={data?.vatAmount === null ? 12 : 6} className="pt-3">
                            <CustomInput model={RequestReimbursementExpense} attribute='amount' data={data?.amount !== 0 ? data?.amount : ""} customChange={(e) => onChange(e, "amount")} />
                        </Col>
                        {data?.vatAmount !== null ? (
                            <Col lg={6} className="pt-3 position-relative">
                                <CustomInput
                                    model={RequestReimbursementExpense}
                                    attribute='vatAmount'
                                    data={data?.vatAmount !== null && data?.vatAmount !== undefined ? data?.vatAmount.toString() : ""}
                                    customChange={(e) => onChange(e, "vatAmount")}
                                />
                                <div className={`error tooltip-custom-up-field ${data?.amount !== 0 && data?.vatAmount !== 0 && data?.amount <= data?.vatAmount ? 'opacity-1' : 'opacity-0'} rfc-error`}>
                                    {t('validationMessage.vatLessAmount')}
                                </div>
                            </Col>
                        ) : ''}

                        {/* 5. Aviso en editMode */}
                        {editMode === true ? (
                            <Col lg={12} className="text-center text-danger">
                                {t('validationMessage.fileDeletedImportant')}
                            </Col>
                        ) : ""}

                        {/* 6. Botones */}
                        <Col lg={12} className="text-end pt-3">
                            {editMode === true ? (
                                <Button className="bg-secondary me-3" onClick={() => { onCancel(cancelModel); setPanelOpen(false); }}>
                                    {t('button.cancel')}
                                </Button>
                            ) : ""}
                            <CustomSubmitButton
                                text={editMode === true ? t('button.save') : t('reimbursement.addExpense')}
                                customClick={async () => {
                                    const isValid = await onValidate();
                                    if (isValid) setPanelOpen(false);
                                }}
                                typeFile={true}
                                formDivRef={formDivRefExpense}
                                //disabled={isButtonDisabled}
                                //tyle={isButtonDisabled ? { opacity: 0.45, cursor: 'not-allowed' } : {}}
                            />
                        </Col>
                    </Row>
                </div>
            </SlidePanel>
        </>
    );
}